import React from 'react';
import './sidebar-content.scss';
import { observer } from 'mobx-react';
import { WebsiteBuilderSidebarTab, WebsiteBuilderSidebarVM } from '../website-builder-sidebar.viewmodel';
import { ManagePagePresentation } from './_manage-page/manage-page.presentation';
import { EditHubPresentation } from './_edit-hub/edit-hub.presentation';

type SidebarContentProps = {
    vm: WebsiteBuilderSidebarVM;
};

const TAB_CONTENT_MAP: Record<WebsiteBuilderSidebarTab, (vm: WebsiteBuilderSidebarVM) => React.ReactNode> = {
    [WebsiteBuilderSidebarTab.ManagePage]: vm => <ManagePagePresentation vm={vm.getManagePageVM()} />,
    [WebsiteBuilderSidebarTab.EditHub]: vm => <EditHubPresentation vm={vm.getEditHubVM()} />,
};

export const SidebarContent = observer(({ vm }: SidebarContentProps) => {
    return (
        <div className='website-builder-sidebar__content'>
            {TAB_CONTENT_MAP[vm.getActiveTab()](vm)}
        </div>
    );
});
